import React, { useEffect, useState } from 'react'
import Modal, { ModalClosingButton } from '../modal'
import CautionIcon from '../../assets/media/icons/caution.svg'
import ListIcon from '../../assets/media/icons/list.svg'
import style from './vinAlternativesModal.css'
import { Radio } from '../form'
import useTranslation from '../../hooks/useTranslation'
import VinStatus from '../../entities/VinStatus'

export type Props = {
    vinDataStatus: VinStatus
    brand: string
    createVehicleCode: Function
    resetVinData: Function
    loadConfigurationByVin: Function
    loadConfigurationByPrString: Function
}

const VinAlternativesModal: React.FC<Props> = (props) => {
    const { vinDataStatus, resetVinData, loadConfigurationByVin, loadConfigurationByPrString} = props
    const { models, alternatives, vinModelName, vinCode } = vinDataStatus
    const [openModalState, setOpenModalState] = useState(false)
    const { t } = useTranslation()

    useEffect(() => {
        if (models || alternatives) {
            setOpenModalState(true)
        }
    }, [models, alternatives])

    if (!models && !alternatives){
        return null
    }
    const closeHandler = (): void => {
        setOpenModalState(false)
        resetVinData()
    }

    const handleSelectedModel = (modelId: string): void => {
        setOpenModalState(false)
        loadConfigurationByVin({vin: vinCode, modelId: modelId})
    }

    const handleSelectedPrString = (prString: string): void => {
        setOpenModalState(false)
        loadConfigurationByPrString(prString)
    }

    return (
        <Modal isVisible={openModalState} onClose={closeHandler}>
            <ModalClosingButton className={style.closeModalButton} onClick={closeHandler} />
            <section className={style.modalContainer}>
                <h2 className={style.modalTitle}>{t('vinAlternativesModal.title')}</h2>
                <div className={style.modalMessage}>
                    <CautionIcon className={style.icon} />
                    <span>{t('vinAlternativesModal.message')}</span>
                </div>
                <div className={style.invocationInfoContainer}>
                    <div className={style.invocationInfo}>
                        <h4 className={style.sectionTitle}>{t('vinAlternativesModal.invocation')}</h4>
                        <div className={style.invocation}>
                            {vinCode}
                        </div>
                    </div>
                    {vinModelName && (
                        <div className={style.invocationInfo}>
                            <h4 className={style.sectionTitle}>{t('vinAlternativesModal.modelInfo.modelName')}</h4>
                            <div className={style.invocation}>
                                {vinModelName}
                            </div>
                        </div>
                    )}
                </div>

                <div className={style.section}>
                    <div className={style.matchingModelsSection}>
                        <ListIcon className={style.icon} />
                        <h3>{t('vinAlternativesModal.matchingModels')}</h3>
                    </div>
                    <div className={style.options}>
                        {models && models.map((model) => (
                            <button key={model.id} className={style.option} onClick={() => handleSelectedModel(model.id)}>
                                <Radio className={style.radio} />
                                <div className={style.modelOptionInfo}>
                                    <span className={style.modelOptionName}>{model.value}</span>
                                    <span className={style.modelOptionId}>{model.id}</span>
                                </div>
                            </button>
                        ))}
                        {alternatives && alternatives.map((prString, index) => (
                            <button key={index} className={`${style.option} ${style.prStringOption}`} onClick={() => handleSelectedPrString(prString)}>
                                <Radio className={style.radio} />
                                <span>{prString}</span>
                            </button>
                        ))}
                    </div>
                </div>
            </section>
        </Modal>
    )
}

export default VinAlternativesModal
